import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class AvatarComponent extends Vue {

  @Prop({ default: null, type: [String] })
  avatarUrl: string;

  @Prop({ default: null, type: [Object] })
  entity: { firstname: string, lastname: string };

  get avatarText(): string {
    console.log(this.entity)
    return `${(this.entity.firstname || '').substring(0, 1)}${(this.entity.lastname || '').substring(0, 1)}`;
  }
}

export default AvatarComponent;


// WEBPACK FOOTER //
// ./src/components/avatar/index.ts